import React from 'react';
import SkeletonLoader from 'src/components/atomic/atoms/skeletonLoader/SkeletonLoader';
import styles from './transactionTypeSkeletonLoader.module.scss';

export default function TransactionTypeSkeletonLoader(): JSX.Element {
    return <SkeletonLoader className={styles.loader} />;
}
